// extracted by mini-css-extract-plugin
export default {"link":"_df74b88f","item":"_3e3c839a","image":"_258f57e8","title":"_f2b207ef"};